export const PLACEHOLDER = "-";
